import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "text-gray-500"
}

import { computed } from "vue"
import FilterGroup from "@/components/filters/FilterGroup.vue"
import { useContactsStore } from "@/stores/contacts"
import { useTaskStore } from "@/stores/task"
import { useAgentsStore } from "@/stores/agents"
import { useGridCollectionStore } from "@/stores/grid-collection"
import { useFormStore } from "@/stores/form"
import { useInboxStore } from "@/stores/inbox"
import { useTemplateStore } from "@/stores/template"
import { useJobsStore } from "@/stores/jobs"
import { useOriginStore } from "@/stores/origin"
import { useEventLogStore } from "@/stores/event-log"
import { useTagStore } from "@/stores/tag"
import { useWorkflowStore } from "@/stores/workflow"
import { useListingStore } from "@/stores/listings"
import { useInvoiceStore } from "@/stores/invoice"
import { useContactListingStore } from "@/stores/contact-listings"
import { useTrackEventStore } from "@/stores/track-event"
import { useLandingPageStore } from "@/stores/landing-page"
import { useMarketingCampaignStore } from "@/stores/marketing-campaign"
import { Filter, FiltersGroup } from "@/shared/models/filter"

interface Props {
    justDisplay?: boolean
    savedFiltersGroups?: FiltersGroup[]
    isWorkflow?: boolean
    branchIndex?: number
    isWorkflowTrigger?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterList',
  props: {
    justDisplay: { type: Boolean, default: false },
    savedFiltersGroups: {},
    isWorkflow: { type: Boolean, default: false },
    branchIndex: { default: 0 },
    isWorkflowTrigger: { type: Boolean, default: false }
  },
  emits: ["addNewFilter", "editFilter", "clearFilters", "removeGroup", "removeFilter", "addNewGroup"],
  setup(__props: any, { emit: __emit }) {

const contactStore = useContactsStore()
const taskStore = useTaskStore()
const agentsStore = useAgentsStore()
const formsStore = useFormStore()
const inboxStore = useInboxStore()
const templateStore = useTemplateStore()
const jobStore = useJobsStore()
const gridCollectionStore = useGridCollectionStore()
const originStore = useOriginStore()
const eventLogStore = useEventLogStore()
const tagStore = useTagStore()
const workflowStore = useWorkflowStore()
const listingStore = useListingStore()
const contactListingStore = useContactListingStore()
const invoiceStore = useInvoiceStore()
const trackEventStore = useTrackEventStore()
const landingPageStore = useLandingPageStore()
const marketingCampaignStore = useMarketingCampaignStore()

const props = __props

const emit = __emit

const filtersGroups = computed(() =>
    !gridCollectionStore.applyFilters
        ? gridCollectionStore.landingPageCreationFilters || []
        : gridCollectionStore.filtersGroups || []
)

function addNewFilterToGroup(index: number) {
    if (props.isWorkflow) {
        workflowStore.branches[props.branchIndex].selectedFilterGroup = index
    } else {
        !gridCollectionStore.applyFilters
            ? (gridCollectionStore.selectedLandingPageFilterGroup = index)
            : (gridCollectionStore.selectedFilterGroup = index)
    }
    if (props.isWorkflowTrigger) {
        emit("addNewFilter", index)
        return
    }
    emit("addNewFilter")
}

async function removeGroup(index: number) {
    if (!gridCollectionStore.applyFilters) {
        gridCollectionStore.landingPageCreationFilters.splice(index, 1)
        return
    }

    if (props.isWorkflowTrigger) {
        emit("removeGroup", index)
        return
    }

    if (props.isWorkflow) {
        workflowStore.branches[props.branchIndex].filtersGroups?.splice(index, 1)
        emit("removeGroup")
        return
    }

    gridCollectionStore.removeGroup(index)

    if (gridCollectionStore.collectionType === "contacts") {
        await contactStore.updateContactsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "tasks") {
        await taskStore.updateTasksGrid()
        return
    }
    if (gridCollectionStore.collectionType === "agents") {
        await agentsStore.updateAgentsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "forms") {
        await formsStore.updateFormsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "inbox") {
        await inboxStore.getInbox()
        return
    }
    if (gridCollectionStore.collectionType === "templates") {
        await templateStore.updateTemplatesGrid()
        return
    }
    if (gridCollectionStore.collectionType === "jobs") {
        await jobStore.updateJobsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "origins") {
        await originStore.updateOriginGrid()
        return
    }
    if (gridCollectionStore.collectionType === "workflows") {
        await workflowStore.updateWorkflowsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "logs") {
        await eventLogStore.updateEventLogsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "tag") {
        await tagStore.updateTagGrid()
        return
    }
    if (gridCollectionStore.collectionType === "listings") {
        await listingStore.updateListingGrid()
        return
    }
    if (gridCollectionStore.collectionType === "contact-listings") {
        await contactListingStore.updateListingGrid()
        return
    }
    if (gridCollectionStore.collectionType === "invoices") {
        await invoiceStore.updateInvoiceGrid()
        return
    }
    if (gridCollectionStore.collectionType === "trackEvents") {
        await trackEventStore.updateTrackEventsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "areas") {
        await landingPageStore.updateLandingPagesGrid()
        return
    }
    if (gridCollectionStore.collectionType === "marketingCampaign") {
        await marketingCampaignStore.updateMarketingCampaignsGrid()
        return
    }
}

function addNewGroup() {
    if (props.isWorkflow) {
        if (workflowStore.branches[props.branchIndex]) {
            workflowStore.branches[props.branchIndex].selectedFilterGroup += 1
        }
    } else {
        !gridCollectionStore.applyFilters
            ? (gridCollectionStore.selectedLandingPageFilterGroup += 1)
            : (gridCollectionStore.selectedFilterGroup += 1)
    }
    emit("addNewFilter")
    emit("addNewGroup")
}

function editFilter(filter: Filter, groupIndex: number, filterIndex: number) {
    if (props.isWorkflow) {
        if (workflowStore.branches[props.branchIndex]) {
            workflowStore.branches[props.branchIndex].selectedFilterGroup = groupIndex
        }
    } else {
        !gridCollectionStore.applyFilters
            ? (gridCollectionStore.selectedLandingPageFilterGroup = groupIndex)
            : (gridCollectionStore.selectedFilterGroup = groupIndex)
    }
    if (props.isWorkflowTrigger) {
        emit("editFilter", filter, groupIndex, filterIndex)
        return
    }
    emit("editFilter", filter, filterIndex)
}

async function removeFilter(groupIndex: number, filterIndex: number) {
    if (!gridCollectionStore.applyFilters) {
        if (gridCollectionStore.landingPageCreationFilters[groupIndex]?.filters) {
            gridCollectionStore.landingPageCreationFilters[groupIndex].filters.splice(filterIndex, 1)
            if (gridCollectionStore.landingPageCreationFilters[groupIndex].filters.length === 0) {
                gridCollectionStore.landingPageCreationFilters.splice(groupIndex, 1)
            }
        }
        emit("removeFilter", groupIndex, filterIndex)
        return
    }
    if (props.isWorkflowTrigger) {
        emit("removeFilter", groupIndex, filterIndex)
        return
    }
    if (props.isWorkflow) {
        workflowStore.branches[props.branchIndex].filtersGroups[groupIndex].filters.splice(filterIndex, 1)
        emit("removeFilter")
        return
    }
    gridCollectionStore.removeFilter(groupIndex, filterIndex)

    if (gridCollectionStore.collectionType === "contacts") {
        await contactStore.updateContactsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "tasks") {
        await taskStore.updateTasksGrid()
        return
    }
    if (gridCollectionStore.collectionType === "agents") {
        await agentsStore.updateAgentsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "forms") {
        await formsStore.updateFormsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "inbox") {
        await inboxStore.getInbox()
        return
    }
    if (gridCollectionStore.collectionType === "templates") {
        await templateStore.updateTemplatesGrid()
        return
    }
    if (gridCollectionStore.collectionType === "jobs") {
        await jobStore.updateJobsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "origin") {
        await originStore.updateOriginGrid()
        return
    }
    if (gridCollectionStore.collectionType === "workflows") {
        await workflowStore.updateWorkflowsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "logs") {
        await eventLogStore.updateEventLogsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "tag") {
        await tagStore.updateTagGrid()
        return
    }
    if (gridCollectionStore.collectionType === "listings") {
        await listingStore.updateListingGrid()
        return
    }
    if (gridCollectionStore.collectionType === "contact-listings") {
        await contactListingStore.updateListingGrid()
        return
    }
    if (gridCollectionStore.collectionType === "invoices") {
        await invoiceStore.updateInvoiceGrid()
        return
    }
    if (gridCollectionStore.collectionType === "trackEvents") {
        await trackEventStore.updateTrackEventsGrid()
        return
    }
    if (gridCollectionStore.collectionType === "areas") {
        await landingPageStore.updateLandingPagesGrid()
        return
    }
    if (gridCollectionStore.collectionType === "marketingCampaign") {
        await marketingCampaignStore.updateMarketingCampaignsGrid()
        return
    }
}

function clearFilters() {
    emit("clearFilters")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.justDisplay)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "text-primary-color-700 text-sm leading-5 font-semibold cursor-pointer",
          onClick: _withModifiers(clearFilters, ["stop"])
        }, "Clear filters"))
      : _createCommentVNode("", true),
    (_ctx.savedFiltersGroups)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedFiltersGroups, (filterGroup, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createVNode(FilterGroup, {
                filters: filterGroup.filters,
                groupIndex: index,
                groupsLength: filtersGroups.value.length,
                justDisplay: _ctx.justDisplay,
                onAddNewFilterToGroup: addNewFilterToGroup,
                onRemoveGroup: removeGroup,
                onRemoveFilter: removeFilter,
                onEditFilter: editFilter
              }, null, 8, ["filters", "groupIndex", "groupsLength", "justDisplay"]),
              (index + 1 < _ctx.savedFiltersGroups.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "OR"))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtersGroups.value, (filterGroup, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createVNode(FilterGroup, {
                filters: filterGroup.filters,
                groupIndex: index,
                groupsLength: filtersGroups.value.length,
                justDisplay: _ctx.justDisplay,
                onAddNewFilterToGroup: addNewFilterToGroup,
                onRemoveGroup: removeGroup,
                onRemoveFilter: removeFilter,
                onEditFilter: editFilter
              }, null, 8, ["filters", "groupIndex", "groupsLength", "justDisplay"]),
              (index + 1 < filtersGroups.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "OR"))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])),
    (!_ctx.justDisplay)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "w-fit px-2 py-0.5 bg-gray-200 text-gray-700 rounded cursor-pointer",
          onClick: _withModifiers(addNewGroup, ["stop"])
        }, " OR "))
      : _createCommentVNode("", true)
  ]))
}
}

})